import { CacheService, IStorageLocal } from "namirasoft-core";
import { EnvironmentRow, NamirasoftInfraServer, ProjectRow } from "namirasoft-infra";

export class InfraCacheService
{
    static getProject(project_id: string, server: NamirasoftInfraServer)
    {
        return new CacheService<ProjectRow>(
            `ns-infra-project-${project_id}`,
            new IStorageLocal(),
            24 * 60,
            async () => "1.0.0", async () => await server.project.Get(project_id)
        );
    }
    static getEnvironment(environment_id: string, server: NamirasoftInfraServer)
    {
        return new CacheService<EnvironmentRow>(
            `ns-infra-environment-${environment_id}`,
            new IStorageLocal(),
            24 * 60,
            async () => "1.0.0", async () => await server.environment.Get(environment_id)
        );
    }
}